export function createOverlay() {
  const overlay = document.createElement("div");
  overlay.style.position = "absolute";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.backgroundColor = "transparent";
  overlay.style.zIndex = "9999";
  overlay.className = "iframe-overlay";
  return overlay;
}

export default function handleIframeScroll(velocity) {
  const iframes = document.querySelectorAll("iframe");

  iframes.forEach((iframe) => {
    iframe.parentNode.style.position = "relative";
    let overlay = iframe.parentNode.querySelector(".iframe-overlay");

    if (!overlay) {
      overlay = createOverlay();
      iframe.parentNode.appendChild(overlay);
    }

    if (velocity !== 0) {
      overlay.style.display = "block";
      iframe.style.pointerEvents = "none";
    } else {
      overlay.style.display = "none";
      iframe.style.pointerEvents = "auto";
    }
  });
}
